export function buildSlideOrderFromHeap(nodeIdToHeapIndex) {
  if (!nodeIdToHeapIndex || typeof nodeIdToHeapIndex !== 'object') {
    return [];
  }

  return Object.entries(nodeIdToHeapIndex)
    .sort(([, heapIndexA], [, heapIndexB]) => heapIndexA - heapIndexB)
    .map(([nodeId]) => nodeId);
}
